import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { isAllowEdit, SUPPLIER_GRADE } from 'features/supplier/utils';

import ModalContainer from '@components/modals/ModalContainer';
import { toastError, toastSuccess } from '@components/Toast';

import InfoPopUp from '@features/supplier/component/InfoPopUp';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import { fetchSupplierDetails } from '@store/supplier/action';

import ApiClient from '@lib/apiClient';

const CoverPhoto = ({ detailsInfo }) => {
	const [supplierDetails, setSupplierDetails] = useState(null);
	const [isUpload, setIsUpload] = useState(false);
	const [errors, setErrors] = useState(null);
	const dispatch = useDispatch();
	const { id } = useParams();
	const inputRef = useRef(null);

	useEffect(() => {
		setSupplierDetails(detailsInfo);
	}, [detailsInfo]);

	const onSaveFactoryImage = async (body) => {
		dispatch(openLoader());
		await ApiClient.PUT('updateSupplierInfo', body, id)
			.then(({ data }) => {
				dispatch(closeLoader());
				if (data && data.success) {
					toastSuccess(data.message);
					dispatch(fetchSupplierDetails(id));
					setIsUpload(false);
				}
			})
			.catch(({ response }) => {
				dispatch(closeLoader());
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	const onImageUpload = (e, docType) => {
		let file = e.target.files[0];
		let data = {
			name: file.name,
			docMimeType: file.type,
			documentType: docType,
			base64Str: ''
		};
		let reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = () => {
			data.base64Str = reader.result;
			setSupplierDetails({
				...supplierDetails,
				profileImageDocUrl: reader.result,
				profileImageDTO: data
			});
		};
		reader.onerror = function (error) {
			toastError(error);
		};
	};

	const isValidForm = () => {
		if (supplierDetails?.name === '' || !supplierDetails?.name) {
			setErrors({ ...errors, nameError: 'Name is required' });
			return false;
		}
		return true;
	};

	const onSubmit = () => {
		const isValid = isValidForm();
		if (!isValid) {
			return;
		}
		let body = {
			name: supplierDetails?.name,
			threeSixtyViewUrl: supplierDetails?.threeSixtyViewUrl,
			profileImageDTO: supplierDetails?.profileImageDTO
		};
		onSaveFactoryImage(body);
	};

	const onUploaderClick = () => {
		if (inputRef && inputRef.current) {
			inputRef.current.click();
		}
	};
	const renderFlag = (country) => {
		if (country?.name === 'Bangladesh')
			return <img src={`${process.env.PUBLIC_URL}/icons/flag.png`} alt="flag" />;
		else if (country?.name === 'China')
			return <img src={`${process.env.PUBLIC_URL}/icons/china.svg`} alt="flag" />;
		else if (country?.name === 'Turkey')
			return <img src={`${process.env.PUBLIC_URL}/icons/turkey.svg`} alt="flag" />;
		else return null;
	};
	return (
		<div>
			<div className="supplier-details-section_v2">
				<div className="suplier-profile-desc">
					<div className="accordion" id="accordionExample">
						<div className="card">
							<div
								id="collapseTwo"
								className="collapse"
								aria-labelledby="headingTwo"
								data-parent="#accordionExample"
							>
								<div className="card-body supplier-thumbnail">
									<div className="profile-img">
										<img
											src={
												supplierDetails?.profileImageDocUrl ||
												`${process.env.PUBLIC_URL}/images/supplier-full-demo.jpg`
											}
											alt="cover-image"
										/>
									</div>
									{isAllowEdit() && (
										<div
											className="edit-btn"
											onClick={() => {
												setIsUpload(true);
											}}
										>
											<button className="button size32">
												<img
													width="20px"
													src={`${process.env.PUBLIC_URL}/icons/upload-white-20.svg`}
													alt="flag"
												/>{' '}
												{supplierDetails?.profileImageDocUrl ? 'Edit' : 'Upload'}
											</button>
										</div>
									)}
								</div>
							</div>
							<div className="card-header" id="headingTwo">
								<h2 className="mb-0">
									<button
										className="collapsed-button text-left collapsed"
										type="button"
										data-toggle="collapse"
										data-target="#collapseTwo"
										aria-expanded="false"
										aria-controls="collapseTwo"
									>
										<span className="profile-button">
											<div className="factory-name-des">
												<div className="factory-name">
													<h3 className="weight-600 d-flex">
														{' '}
														<span className="title">{supplierDetails?.name}</span>
														<span className="grade-list">
															<span
																className={`factory-grade  ${
																	SUPPLIER_GRADE[
																		supplierDetails?.supplierGrading
																	]
																} font-weight-bold`}
															>
																{supplierDetails?.supplierGrading && (
																	<InfoPopUp
																		gradeId={
																			supplierDetails?.supplierGrading
																		}
																		iconType={'GRADE'}
																		hoverTag={supplierDetails?.supplierGrading?.slice(
																			-1
																		)}
																	/>
																)}
															</span>
														</span>
													</h3>
													<span className="location mt-12">
														{renderFlag(
															supplierDetails?.factoryLocation?.countryResponse
														)}
														<p className="regular-16 font-weight-normal">
															{supplierDetails?.factoryLocation?.city &&
																supplierDetails?.factoryLocation?.city + ', '}
															{
																supplierDetails?.factoryLocation
																	?.countryResponse?.name
															}
														</p>
													</span>
												</div>
											</div>
											<span className="vertual-btn_arrow">
												{supplierDetails?.threeSixtyViewUrl && (
													<div className="degree-btn">
														<a
															href={supplierDetails?.threeSixtyViewUrl}
															target="_blank"
															rel="noreferrer"
														>
															<img
																src={`${process.env.PUBLIC_URL}/images/360.png`}
																alt={360}
															/>
														</a>
													</div>
												)}
												<div className="arrow-down">
													<img
														src={`${process.env.PUBLIC_URL}/icons/down-arrow-gray-dark-02.svg`}
														alt="arrow"
													/>
												</div>
											</span>
										</span>
									</button>
								</h2>
							</div>
						</div>
					</div>
				</div>
			</div>

			{isUpload && (
				<ModalContainer>
					<div className="common-popup supplier-upload-modal shadow-24dp">
						<div className="common-popup-header d-flex justify-content-between">
							<div className="popup-tilte">
								<h3 className="semibold-16 mb-0">Edit</h3>
							</div>
							<div
								className="close-btn"
								onClick={() => {
									setSupplierDetails(detailsInfo);
									setIsUpload(false);
								}}
							>
								<img src={`${process.env.PUBLIC_URL}/icons/close.svg`} alt="close" />
							</div>
						</div>
						<div className="common-popup-body">
							<div className="row">
								<div className="col-md-12 pr-2">
									<div className="upload-img mb-2">
										<div
											className={`${
												supplierDetails?.profileImageDocUrl
													? 'file-editing'
													: 'file-uploader small upload-design-image mb-4 mb-sm-0'
											}`}
										>
											{supplierDetails?.profileImageDocUrl && (
												<>
													<img
														src={supplierDetails?.profileImageDocUrl}
														alt="edit"
													/>
													<div className="action-icon" onClick={onUploaderClick}>
														<img
															width="20px"
															src={`${process.env.PUBLIC_URL}/icons/upload-gray.svg`}
															alt="check"
														/>
													</div>{' '}
												</>
											)}
											<label
												htmlFor="drag-upload"
												className="drag-upload"
												onClick={onUploaderClick}
											/>
											<input
												ref={inputRef}
												onClick={(e) => (e.target.value = null)}
												type="file"
												className="file-upload d-none"
												name="image"
												onChange={(e) => onImageUpload(e, 'SUPPLIER_PHOTO_DOCUMENT')}
												accept="image/*"
											/>
										</div>
									</div>
								</div>
								<div className="col-md-12 pr-2">
									<div className="form-group">
										<label htmlFor="collection">360 Degree link</label>
										<input
											type="text"
											autoComplete="off"
											placeholder="www.webaddress.com"
											className="w-100"
											value={supplierDetails?.threeSixtyViewUrl}
											onChange={(e) =>
												setSupplierDetails({
													...supplierDetails,
													threeSixtyViewUrl: e.target.value
												})
											}
										/>
									</div>
								</div>
								<div className="col-md-12 pr-2">
									<div className="form-group">
										<label htmlFor="collection">Supplier name *</label>
										<input
											type="text"
											autoComplete="off"
											className="w-100"
											value={supplierDetails?.name}
											onChange={(e) =>
												setSupplierDetails({
													...supplierDetails,
													name: e.target.value
												})
											}
										/>
										{errors?.nameError && <p className="error">{errors?.nameError}</p>}
									</div>
								</div>
							</div>
						</div>
						<div className="modal-footer">
							<div className="footer-buttons text-right">
								<button
									className="button gray-outline size32"
									onClick={() => {
										setSupplierDetails(detailsInfo);
										setIsUpload(false);
									}}
								>
									Cancel
								</button>
								<button className="button size32 ml-2" onClick={onSubmit}>
									Submit
								</button>
							</div>
						</div>
					</div>
				</ModalContainer>
			)}
		</div>
	);
};

export default CoverPhoto;
